import {PolymerElement, html} from '@polymer/polymer';
import {ScopeBinding} from './behaviors/keli-binding-behavior.js';
import {renderKeliMarkdown} from '../javascripts/modules/renderKeliMarkdown.js';

class KeliBanner extends ScopeBinding(PolymerElement) {
  static get template() {
    return html`
<style>
  :host {
    display: none;
    padding: .5em;
    background-color: var(--keli-theme-blue-grey-600);
    color: var(--keli-text-light);
    --keli-a-color: var(--keli-a-color-light);
    font-weight: 300;
  }

  :host(.visible) {
    display: block;
  }

  :host(.success) {
    background-color: var(--keli-theme-green-800);
    color: var(--keli-text-light);
    --keli-a-color: var(--keli-a-color-light);
  }

  :host(.warning) {
    background-color: var(--keli-theme-yellow-500);
    color: var(--keli-text-dark);
    --keli-a-color: var(--keli-a-color-dark);
  }

  :host(.error) {
    background-color: var(--keli-theme-red-700);
    color: var(--keli-text-light);
    --keli-a-color: var(--keli-a-color-light);
  }
</style>

<div id="text"></div>`;
  }

  static get is() {
    return 'keli-banner'
  }

  static get properties() {
    return {
      keliControlTypes: {type: Array, value: ['banner']},
      isBlockPanelElement: {type: Boolean, value: true},
      value: {type: String, scopevar: 'bannervalue', observer: 'valueChanged'},
      type: {type: String, scopevar: 'bannertype', observer: 'bannerTypeChanged'},
      align: {type: String, scopevar: true, observer: 'alignChanged'}
    }
  }

  bannerTypeChanged(newValue, oldValue) {
    if (oldValue) {
      this.classList.remove(oldValue);
    }
    if (newValue && typeof newValue === 'string') {
      this.classList.add(newValue);
    }
  }

  valueChanged(newValue) {
    if (newValue) {
      this.classList.add('visible');
      renderKeliMarkdown(newValue, this.$.text, {preventSolitaryParagraph: true});
    } else {
      this.classList.remove('visible');
      this.$.text.innerHTML = '';
    }
  }

  alignChanged(newValue) {
    if (newValue) {
      this.$.text.style.textAlign = newValue;
    } else {
      this.$.text.style.textAlign = '';
    }
  }
}

customElements.define(KeliBanner.is, KeliBanner);
export {KeliBanner};